import { style, animate, transition, trigger } from '@angular/animations';

export const fadeIn: any = trigger('fadeIn', [
    transition(':enter', [style({ opacity: 0 }), animate(200, style({ opacity: 1 }))]),
]);
